function scrollToReviewSection() {
	const ratingBadge = document.querySelector('.rating-badge');
	const reviewSection = document.querySelector('#judgeme_product_reviews');
	if (ratingBadge && reviewSection) {
		ratingBadge.addEventListener('click', function(event) {
			event.preventDefault();

			// Calculate position with offset
			const offsetPosition = reviewSection.getBoundingClientRect().top + window.pageYOffset - 230;

			// Scroll to the adjusted position
			window.scrollTo({
						top: offsetPosition,
				behavior: 'smooth'
			});
		});
	}
}
scrollToReviewSection();
console.log('test');